import * as React from "react";
import SelectInput from "./SelectInput";

const MultiSelect = ({
  size = "default",
  placeholder,
  value,
  onChange,
  style,
  options,
  selectOptionKey,
  selectOptionValue,
  mode = "tags",
  notFoundContent,
  onSearch
}: {
  size?: "default" | "large" | "small";
  placeholder?: string;
  value?: any;
  onChange?: (selectedKeys: any[]) => void;
  style?: any;
  options: any[];
  selectOptionKey: any;
  selectOptionValue: any;
  mode?: any;
  notFoundContent?: string;
  onSearch?: (value: string) => void;
}) => {
  return (
    <SelectInput
      mode={mode}
      size={size}
      placeholder={placeholder}
      value={value}
      onChange={value => onChange && onChange(value)}
      style={style}
      selectOptionKey={selectOptionKey}
      selectOptionValue={selectOptionValue}
      selectOptions={options}
      notFoundContent={notFoundContent}
      onSearch={onSearch}
    />
  );
};

export default MultiSelect;
